@if ({
  row: columnData | async,
  adata: additionData | async
  }; as $) {
  @if ($.adata.is_campaign) {
    <div (click)="onGoToRoute($.adata?.uri, $.row)" class="cursor-pointer">
      <div class="bg{{$.row?.color}}-400 h-full absolute left-0 top-0 py-2 pl-2"></div>
      <strong class="block">{{ $.row[$.adata.keyName] }}</strong>
      <div class="text-600 mt-1 white-space-normal max-w-15rem">{{ $.row[$.adata.keyName1] }}</div>
    </div>
  }
  @if (!$.adata.is_campaign) {
    <div class="cursor-pointer" (click)="onGoToRoute($.adata?.uri, $.row)">
      <div class="flex align-items-center">
        <strong class="block">{{ $.row[$.adata.keyName] }}</strong>
        <strong class="surface-0 px-2 py-1 border-round text-primary border-1 border-primary text-xs ml-2">{{ 'AUTOMATION.EVENT.'+$.row[$.adata.keyName2] | translate}}</strong>
      </div>
      <div class="text-600 mt-1 max-w-25rem font-normal">{{ $.row[$.adata.keyName1]}}</div>
    </div>
  }
}
